/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_summary_browse_folder_contains27 = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("en", i.count, {});
	if (countPlural == "zero") return `Empty Folder`;
	if (countPlural == "one") return `${i.count} File`;
	if (countPlural == "other") return `${i.count} Files`;
	return "SUMMARY_BROWSE_FOLDER_CONTAINS";
};

const fr_summary_browse_folder_contains27 = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("fr", i.count, {});
	if (countPlural == "zero") return `Dossier vide`;
	if (countPlural == "one") return `${i.count} Fichier`;
	if (countPlural == "other") return `${i.count}`;
	return "SUMMARY_BROWSE_FOLDER_CONTAINS";
};

const de_summary_browse_folder_contains27 = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("de", i.count, {});
	if (countPlural == "zero") return `Ordner leeren`;
	if (countPlural == "one") return `${i.count}`;
	if (countPlural == "other") return `${i.count} Dateien`;
	return "SUMMARY_BROWSE_FOLDER_CONTAINS";
};

const es_summary_browse_folder_contains27 = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("es", i.count, {});
	if (countPlural == "zero") return `Carpeta vacía`;
	if (countPlural == "one") return `${i.count}`;
	if (countPlural == "other") return `Archivos ${i.count}`;
	return "SUMMARY_BROWSE_FOLDER_CONTAINS";
};

const it_summary_browse_folder_contains27 = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("it", i.count, {});
	if (countPlural == "zero") return `Cartella vuota`;
	if (countPlural == "one") return `${i.count}`;
	if (countPlural == "other") return `${i.count} File`;
	return "SUMMARY_BROWSE_FOLDER_CONTAINS";
};

const ar_summary_browse_folder_contains27 = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {const countPlural = registry.plural("ar", i.count, {});
	if (countPlural == "zero") return `مجلد فارغ`;
	if (countPlural == "one") return `${i.count}`;
	if (countPlural == "other") return `${i.count} ملفات`;
	return "SUMMARY_BROWSE_FOLDER_CONTAINS";
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ count: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const summary_browse_folder_contains27 = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.summary_browse_folder_contains27(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("summary_browse_folder_contains27", locale)
	if (locale === "en") return en_summary_browse_folder_contains27(inputs)
	if (locale === "fr") return fr_summary_browse_folder_contains27(inputs)
	if (locale === "de") return de_summary_browse_folder_contains27(inputs)
	if (locale === "es") return es_summary_browse_folder_contains27(inputs)
	if (locale === "it") return it_summary_browse_folder_contains27(inputs)
	return ar_summary_browse_folder_contains27(inputs)
};
export { summary_browse_folder_contains27 as "SUMMARY_BROWSE_FOLDER_CONTAINS" }